import React from "react";
import { makeStyles } from  "@material-ui/core/styles"
import { Typography, Grid } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import image from "../../images/image-403.svg";

const style = makeStyles((theme) => ({

  image: {
    [theme.breakpoints.up("xs")]: {
      width: "40%", 
      height: "fit-content", 
      marginTop: "-30px", 
      marginLeft: "30%", 
      position: "relative"
    },
      [theme.breakpoints.up("sm")]: {
        width: "337px", 
        height: "fit-content", 
        marginLeft: "5%", 
        position: "relative",
        minHeight: '300px',
      },
      [theme.breakpoints.up("md")]: {
        width: "40%", 
        height: "fit-content", 
        marginLeft: "10%", 
        position: "relative",
        minHeight: '600px',
      },
      [theme.breakpoints.down("lg")]: {
        width: "150px", 
        height: "fit-content", 
        marginLeft: "35%", 
        position: "relative",
        minHeight: '300px',
      },
      [theme.breakpoints.up("lg")]: {
        width: "337px", 
        height: "fit-content", 
        marginLeft: "5%", 
        position: "relative",
        minHeight: '600px',
        
      },
    },
    title: {
      [theme.breakpoints.up("lg")]: {
        position: "relative",
        width: '431px',
        height: '70px',
        left: '202px',
        top: '15px',
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '100px',
        lineHeight: '16px',
        letterSpacing: '0.4px',
        color: '#4C8B8E',
      },
      [theme.breakpoints.down("sm")]: {
        position: "relative",
        width: '431px',
        height: '70px',
        left: '202px',
        top: '40px',
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '30px',
        lineHeight: '16px',
        letterSpacing: '0.4px',
        color: '#4C8B8E',
        marginTop: '40%'
      },
    },
    subtitle: {
      [theme.breakpoints.up("sm")]: {
        position: "relative",
        width: '595px',
        height: '39px',
        left: '202px',
        top: '5px',
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '50px',
        letterSpacing: '0.4px',
        color: '#4C8B8E',
      },
      [theme.breakpoints.down("sm")]: {
        position: "relative",
        width: '595px',
        height: '39px',
        left: '202px',
        top: '5px',
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '25px',
        letterSpacing: '0.4px',
        color: '#4C8B8E',
      },
    },
    container: {
      [theme.breakpoints.up("lg")]: {
        height: "100%", 
        display: "flex", 
        justifyContent: "center", 
        alignItems: "center",
        // marginTop: '10%'
        
      },
      [theme.breakpoints.up("sm")]: {
        height: "100%", 
        display: "flex", 
        justifyContent: "center", 
        alignItems: "center",
        // marginTop: '25%'
      },
      [theme.breakpoints.down("lg")]: {
        height: "100%", 
        display: "flex", 
        justifyContent: "center", 
        alignItems: "center",
      },
    },
  submit: {
    marginLeft: "40%",
    background: "#4D8D9D",
    "&:hover": {
      background: "#4D8D9D",
    },
  },
}));

const NoAuthorized = (props) => {
  
  const classes = style();

  return (
    <Grid container spacing={0} className={classes.container} >
      <Grid item xs={6}  sm={6} md={6} style={{marginBottom: '15%'}}>
            <Typography
              component="h1"
              variant="h5"
              className={classes.title}
            >
              <b>Error 403</b>
            </Typography>
            <Typography
              component="h1"
              variant="h5"
              className={classes.subtitle}
            >
              <b>Acceso denegado</b>
            </Typography>
      </Grid>
      <Grid item xs={6} sm={6} md={6} >
        <div >
          <img
            alt="nurse"
            src={image}
            className={classes.image}
          />
       
        </div> 
      </Grid>
    </Grid>
  );
};

export default withRouter(NoAuthorized);


